"use strict";

var _typeof = require("@babel/runtime-corejs3/helpers/typeof");
var _Object$keys = require("@babel/runtime-corejs3/core-js-stable/object/keys");
var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols");
var _filterInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/filter");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors");
var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.PopoverBase = exports.POPOVER_TYPES = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/slicedToArray"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));
var _chainFunction = _interopRequireDefault(require("chain-function"));
var _bind = _interopRequireDefault(require("classnames/bind"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _reactMergeRefs = _interopRequireDefault(require("react-merge-refs"));
var _CustomPropTypes = _interopRequireDefault(require("../utils/CustomPropTypes"));
var _focusManager = require("../utils/focusManager");
var _Icon = require("../Icon/Icon");
var _useUniqueId = require("../utils/useUniqueId");
var _IconButton = require("../IconButton/IconButton");
var _useOnClickOutside = require("../utils/_useOnClickOutside");
var _AddChildPropsContext = require("../utils/_AddChildPropsContext");
var _Popper = require("../utils/_Popper");
var _PopoverBase = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./PopoverBase.css") : void 0);
var _excluded = ["arrowClassName", "disableHideWhenTargetIsHidden", "children", "className", "flipContainer", "footer", "footerProps", "id", "message", "offset", "placement", "popperContentProps", "popperMiddleware", "popperProps", "show", "skidding", "targetProps", "textClose", "title", "titleBarClassName", "titleClassName", "onCloseClicked", "onHide", "targetClassName", "type", "width", "additionalTitleContentEnd", "titleContentStartContainerProps", "additionalTitleContentStart", "hideCloseButton", "titleContentEndContainerProps"],
  _excluded2 = ["className"];
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? Object.defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
var CSS_BLOCK = 'sapcnqr-popover';
var POPOVER_TYPES = exports.POPOVER_TYPES = ['success', 'info', 'warning', 'error'];
var PopoverBase = exports.PopoverBase = /*#__PURE__*/_react.default.forwardRef(function (props, ref) {
  var addChildProps = (0, _AddChildPropsContext.useAddChildProps)();
  var _ref = addChildProps ? _objectSpread(_objectSpread({}, props), addChildProps(PopoverBase, props)) : props,
    arrowClassName = _ref.arrowClassName,
    disableHideWhenTargetIsHidden = _ref.disableHideWhenTargetIsHidden,
    children = _ref.children,
    className = _ref.className,
    flipContainer = _ref.flipContainer,
    footer = _ref.footer,
    footerProps = _ref.footerProps,
    id = _ref.id,
    message = _ref.message,
    _ref$offset = _ref.offset,
    offset = _ref$offset === void 0 ? 10 : _ref$offset,
    _ref$placement = _ref.placement,
    placement = _ref$placement === void 0 ? ['right', 'left', 'top', 'bottom'] : _ref$placement,
    popperContentProps = _ref.popperContentProps,
    popperMiddleware = _ref.popperMiddleware,
    popperProps = _ref.popperProps,
    _ref$show = _ref.show,
    showProp = _ref$show === void 0 ? false : _ref$show,
    skidding = _ref.skidding,
    targetProps = _ref.targetProps,
    textClose = _ref.textClose,
    title = _ref.title,
    titleBarClassName = _ref.titleBarClassName,
    titleClassName = _ref.titleClassName,
    onCloseClicked = _ref.onCloseClicked,
    onHide = _ref.onHide,
    targetClassName = _ref.targetClassName,
    type = _ref.type,
    width = _ref.width,
    additionalTitleContentEnd = _ref.additionalTitleContentEnd,
    titleContentStartContainerProps = _ref.titleContentStartContainerProps,
    additionalTitleContentStart = _ref.additionalTitleContentStart,
    hideCloseButton = _ref.hideCloseButton,
    titleContentEndContainerProps = _ref.titleContentEndContainerProps,
    otherProps = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var _useState = (0, _react.useState)(showProp),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    show = _useState2[0],
    setShow = _useState2[1];
  var previousShowRef = (0, _react.useRef)(showProp);
  var popoverRef = (0, _react.useRef)();
  var _focusManagerRef = (0, _react.useRef)();
  var targetRef = (0, _react.useRef)();
  var uniqueId = (0, _useUniqueId.useUniqueId)();
  if (id) {
    uniqueId = id;
  }
  (0, _react.useEffect)(function () {
    setShow(showProp);
  }, [showProp]);
  (0, _react.useEffect)(function () {
    if (previousShowRef.current && !show) {
      var _targetRef$current;
      onHide === null || onHide === void 0 || onHide();
      (_targetRef$current = targetRef.current) === null || _targetRef$current === void 0 || _targetRef$current.focus();
      _focusManagerRef.current = null;
    }
    previousShowRef.current = show;
  }, [show]);
  var handleClickOutside = function handleClickOutside(e) {
    var _popoverRef$current;
    if (e && (_popoverRef$current = popoverRef.current) !== null && _popoverRef$current !== void 0 && _popoverRef$current.contains(e.target)) {
      return;
    }
    setShow(false);
  };
  (0, _useOnClickOutside.useOnClickOutside)({
    ref: popoverRef,
    handleClickOutside: handleClickOutside,
    show: show
  });
  var _handleFocusManager = function _handleFocusManager() {
    if (show && popoverRef.current && !_focusManagerRef.current) {
      _focusManagerRef.current = new _focusManager.FocusManager({
        trapNode: popoverRef.current
      });
    }
  };
  var _onCloseClicked = function _onCloseClicked(e) {
    setShow(false);
    onCloseClicked === null || onCloseClicked === void 0 || onCloseClicked(e);
  };
  var _handleClick = function _handleClick() {
    setShow(true);
  };
  var classnames = _bind.default.bind(_PopoverBase.default);
  var popperClassName = classnames(CSS_BLOCK, className, (0, _defineProperty2.default)({}, "".concat(CSS_BLOCK, "--custom-size"), !!width));
  var popperStyleProps = popperProps === null || popperProps === void 0 ? void 0 : popperProps.style;
  if (width) {
    popperStyleProps = _objectSpread(_objectSpread({}, popperStyleProps), {}, {
      width: width
    });
  }
  var passChildProps = function passChildProps(child, childProps) {
    if (child.displayName === 'Toolbar') {
      return {
        className: classnames("".concat(CSS_BLOCK, "__toolbar"), childProps === null || childProps === void 0 ? void 0 : childProps.className),
        toolbarStyle: 'transparent'
      };
    }
    return null;
  };
  var extendedPopperProps = _objectSpread(_objectSpread({
    'aria-describedby': "".concat(uniqueId, "-content"),
    'aria-labelledby': "".concat(uniqueId, "-title"),
    'data-testid': uniqueId,
    id: uniqueId,
    role: 'dialog'
  }, popperProps), {}, {
    style: popperStyleProps
  });
  var child = _react.default.Children.only(children);
  var mergedChildRef = child.ref ? (0, _reactMergeRefs.default)([child.ref, targetRef]) : targetRef;
  var targetComponent = /*#__PURE__*/_react.default.cloneElement(child, {
    'aria-controls': show ? uniqueId : null,
    'aria-expanded': show,
    'aria-haspopup': 'dialog',
    onClick: (0, _chainFunction.default)(_handleClick, child.props.onClick),
    ref: mergedChildRef
  });
  var _ref2 = popperContentProps || {},
    popperContentClassName = _ref2.className,
    otherPopperContentProps = (0, _objectWithoutProperties2.default)(_ref2, _excluded2);
  return /*#__PURE__*/_react.default.createElement(_Popper.Popper, {
    arrowClassName: classnames("".concat(CSS_BLOCK, "__arrow"), arrowClassName),
    disableHideWhenTargetIsHidden: disableHideWhenTargetIsHidden,
    flipContainer: flipContainer,
    offset: offset,
    skidding: skidding,
    onEscapeKey: _onCloseClicked,
    popperClassName: popperClassName,
    popperContentProps: _objectSpread(_objectSpread({}, otherPopperContentProps), {}, {
      className: classnames("".concat(CSS_BLOCK, "__wrapper"), popperContentClassName)
    }),
    popperMiddleware: popperMiddleware,
    popperPlacement: placement,
    popperProps: extendedPopperProps,
    show: show,
    showArrow: true,
    targetClassName: targetClassName,
    targetComponent: targetComponent,
    targetProps: targetProps
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classnames("".concat(CSS_BLOCK, "__dialog")),
    ref: (0, _reactMergeRefs.default)([ref, popoverRef, _handleFocusManager])
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classnames("".concat(CSS_BLOCK, "__titlebar"), (0, _defineProperty2.default)({}, "".concat(CSS_BLOCK, "__titlebar--wrap"), additionalTitleContentEnd), titleBarClassName)
  }, /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, titleContentStartContainerProps, {
    className: classnames("".concat(CSS_BLOCK, "__title-content"), titleContentStartContainerProps === null || titleContentStartContainerProps === void 0 ? void 0 : titleContentStartContainerProps.className)
  }), additionalTitleContentStart, type && /*#__PURE__*/_react.default.createElement(_Icon.Icon, {
    ariaHidden: true,
    className: classnames("".concat(CSS_BLOCK, "__icon")),
    iconName: "messaging-".concat(type)
  }), /*#__PURE__*/_react.default.createElement("span", {
    className: classnames("".concat(CSS_BLOCK, "__title"), titleClassName),
    id: "".concat(uniqueId, "-title")
  }, title)), (additionalTitleContentEnd || !hideCloseButton) && /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, titleContentEndContainerProps, {
    className: classnames("".concat(CSS_BLOCK, "__title-content"), titleContentEndContainerProps === null || titleContentEndContainerProps === void 0 ? void 0 : titleContentEndContainerProps.className)
  }), additionalTitleContentEnd, !hideCloseButton && /*#__PURE__*/_react.default.createElement(_IconButton.IconButton, (0, _extends2.default)({
    ariaLabel: textClose
  }, otherProps, {
    className: classnames("".concat(CSS_BLOCK, "__action"), otherProps.className),
    iconName: "close",
    iconProps: _objectSpread(_objectSpread({}, otherProps.iconProps), {}, {
      forceSize: 'xs-plus'
    }),
    muted: true,
    onClick: _onCloseClicked,
    tooltipDelay: -1
  })))), /*#__PURE__*/_react.default.createElement("div", {
    className: classnames("".concat(CSS_BLOCK, "__content")),
    id: "".concat(uniqueId, "-content")
  }, message), footer && /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, footerProps, {
    className: classnames("".concat(CSS_BLOCK, "__footer"), footerProps === null || footerProps === void 0 ? void 0 : footerProps.className)
  }), /*#__PURE__*/_react.default.createElement(_AddChildPropsContext.AddChildPropsProvider, {
    value: passChildProps
  }, footer))));
});
PopoverBase.displayName = 'PopoverBase';
PopoverBase.propTypes = {
  /** Collection of React components to be placed in popover’s content area. */
  message: _propTypes.default.node.isRequired,
  /** Localized assistive text for the close button. */
  textClose: _CustomPropTypes.default.localizedString('CoreUIComponents.close').isRequired,
  /** Popover heading text. */
  title: _propTypes.default.node.isRequired,
  /** Custom classes for the arrow element. */
  arrowClassName: _propTypes.default.string,
  /** React component to which the popover will be attached. */
  children: _propTypes.default.node,
  /** Custom classes for the popover wrapper. */
  className: _propTypes.default.string,
  /** Disable hiding the popover when the target element is scrolled past or otherwise hidden. */
  disableHideWhenTargetIsHidden: _propTypes.default.bool,
  /** Used to create a boundary for the underlying Popper to stay within. */
  flipContainer: _CustomPropTypes.default.elementOrArrayOfElements(),
  /** Used to build `id` attributes for accessibility reasons. */
  id: _propTypes.default.string,
  /** Controls **Popper** offset */
  offset: _propTypes.default.number,
  /** Placement of the popover relative to the target element.
   * Options are `'auto'`, `'auto-start'`, `'auto-end'`, `'top'`, `'top-start'`, `'top-end'`,
   * `'bottom'`, `'bottom-start'`, `'bottom-end'`, `'left'`, `'left-start'`, `'left-end'`,
   * `'right'`, `'right-start'`, `'right-end'`.
   * If you use an array of strings, the first item in the array is the default placement
   * and the following ones are chosen in order as fallback placements if the preceding
   * ones don’t work. */
  placement: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.oneOf(_Popper.POPPER_PLACEMENTS)), _propTypes.default.oneOf(_Popper.POPPER_PLACEMENTS)]),
  /** Additional props to spread to the content of the popper. */
  popperContentProps: _propTypes.default.object,
  /** Middleware to use with the popper.  See Floating-UI documentation for specifics:
   * https://floating-ui.com/docs/middleware
   */
  popperMiddleware: _propTypes.default.array,
  /** Additional props to spread to the popper wrapper. */
  popperProps: _propTypes.default.object,
  /** Controls whether the popover is visible. */
  show: _propTypes.default.bool,
  /** Controls **Popper** skidding */
  skidding: _propTypes.default.number,
  /** Additional props for the target/reference element. */
  targetProps: _propTypes.default.object,
  /** Custom classes for the target/reference element. */
  targetClassName: _propTypes.default.string,
  /** Custom classes for the titlebar `<div>` element. */
  titleBarClassName: _propTypes.default.string,
  /** Custom classes for the title `<span>` element. */
  titleClassName: _propTypes.default.string,
  /** @ignore */
  type: _propTypes.default.oneOf(POPOVER_TYPES),
  /** The custom width of the popover. The value must specify the units as well as
   * the value (e.g. `200px`, `40vw` or `30%`). When a custom width is used, the
   * popover receives a maximum height and content within the popover will scroll,
   * if necessary. */
  width: _propTypes.default.string,
  /** Additional node content prepended to the title container. */
  additionalTitleContentStart: _propTypes.default.node,
  /** Additional node content append to the title container. */
  additionalTitleContentEnd: _propTypes.default.node,
  /** Set to `true` to hide the "Close" **IconButton** in the **Popover** header. */
  hideCloseButton: _propTypes.default.bool,
  /** Properties to spread to the additional title container DIV element added when using `additionalTitleContentStart`. */
  titleContentStartContainerProps: _propTypes.default.node,
  /** Properties to spread to the additional title container DIV element added when using `additionalTitleContentEnd`. */
  titleContentEndContainerProps: _propTypes.default.node,
  /** Content to render inside the footer container. */
  footer: _propTypes.default.node,
  /** Properties to spread to the footer container DIV element added when using `footer`. */
  footerProps: _propTypes.default.object,
  /** Callback function fired when the close button is clicked. If this is not passed,
   * an attempt will be made to fire the `onHide` function instead. */
  onCloseClicked: _propTypes.default.func,
  /** Callback function fired when the popover is hidden
   * (typically with a click outside of the popover). */
  onHide: _propTypes.default.func
};
var _default = exports.default = PopoverBase;